var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undo 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.14539 15.7049C4.58689 18.6869 7.56739 20.8139 11.1059 20.9969C16.2734 21.2654 20.6864 17.2874 20.9534 12.1199C21.2219 6.95391 17.2439 2.54091 12.0764 2.27241C9.22339 2.12541 6.60139 3.26991 4.77889 5.19591C4.35139 5.64741 4.37239 6.35991 4.82239 6.78741C5.27389 7.21341 5.98639 7.19391 6.41389 6.74241C7.79839 5.27841 9.79189 4.40691 11.9609 4.51941C15.8879 4.72341 18.9104 8.07741 18.7064 12.0044C18.5024 15.9314 15.1499 18.9539 11.2229 18.7499C8.53189 18.6104 6.26689 16.9934 5.17189 14.7269C4.90189 14.1674 4.22839 13.9319 3.66889 14.2034C3.10939 14.4734 2.87539 15.1454 3.14539 15.7049Z",
    fill: "#00C851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17849 3.27546L3.95949 7.51296C3.92799 8.13396 4.40349 8.66196 5.02449 8.69496L9.26199 8.91396C9.88149 8.94696 10.411 8.46846 10.444 7.84896C10.4755 7.22946 9.99849 6.69996 9.37749 6.66696L6.26499 6.50646L6.42549 3.39246C6.45849 2.77296 5.98149 2.24346 5.36049 2.21046C4.74099 2.17896 4.21149 2.65596 4.17849 3.27546Z",
    fill: "#00C851"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.b598002777c9f7885596f92465d8658f.svg";
export { ForwardRef as ReactComponent };